
import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Twitter, Linkedin, Mail, Phone, MapPin } from 'lucide-react';
import { getPropertiesGroupedByField } from '../../services/property';
import { capitalizeWords } from '../../helper';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [groupedProperties, setGroupedProperties] = React.useState<any[]>([]);



  React.useEffect(() => {
    const fetchProperties = async () => {
      try {
        const response = await getPropertiesGroupedByField('propertyType');
        if (response.properties) {
          setGroupedProperties(response.properties);
        }
      } catch (error) {
        console.error("Failed to fetch properties for footer:", error);
      }
    };
    fetchProperties();
  }, []);

  return (
    <footer className="glass-card-strong mt-16 border-t-2 border-white/20 rounded-none">
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="mb-4">
              <img
                src="/image/logo.png"
                alt="PropVerse Logo"
                className="h-8 w-auto object-contain"
              />
            </div>
            <p className="text-foreground/70 max-w-xs text-sm tracking-wide">
              Urban Oasis is a company incorporated in the United Arab Emirates, based in Dubai, with the objective to add transparency to the UAE Real Estate Market by delivering Unique Real Estate Knowledge and Remarkable Experience to its customers.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/profile.php?id=61556310607163"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/70 hover:text-gold transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a
                href="https://www.instagram.com/urbanoasis.properties/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/70 hover:text-gold transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a
                href="https://www.linkedin.com/company/urban-oasis-properties-dubai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/70 hover:text-gold transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="h-5 w-5" />
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-foreground/70 hover:text-gold transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold uppercase tracking-wider">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/properties"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  Properties
                </Link>
              </li>
              <li>
                <Link
                  to="/developers"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  Developers
                </Link>
              </li>
              <li>
                <Link
                  to="/locations"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  Locations
                </Link>
              </li>
              <li>
                <Link
                  to="/market-insights"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  Market Insights
                </Link>
              </li>
              <li>
                <Link
                  to="/blogs"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  Blog
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold uppercase tracking-wider">Resources</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/mortgage-calculator"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  Mortgage Calculator
                </Link>
              </li>
              <li>
                <Link
                  to="/broker/login"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  Broker Login
                </Link>
              </li>
              <li>
                <Link
                  to="/admin/login"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  Admin Login
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/privacy-policy"
                  className="text-foreground/70 hover:text-gold transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-of-service"
                  className="text-foreground/70 hover:text-gold transition-colors"
                >
                  Terms of Service
                </Link>
              </li> */}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold uppercase tracking-wider">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <MapPin className="h-5 w-5 mr-2 text-gold shrink-0 mt-0.5" />
                <span className="text-foreground/70 text-sm">
                  Office 1862 , Tamani arts office building, Business Bay, UAE.
                </span>
              </li>
              <li className="flex items-center">
                <Phone className="h-5 w-5 mr-2 text-gold shrink-0" />
                <a
                  href="tel:+971588995586"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  +971 58 899 5586
                </a>
              </li>
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 text-gold shrink-0" />
                <a
                  href="mailto:leads@urbanoasis.ae"
                  className="text-foreground/70 hover:text-gold transition-colors text-sm"
                >
                  leads@urbanoasis.ae
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Properties by Type Section */}
        {groupedProperties.length > 0 && (
          <div className="py-10 border-t border-white/10">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {groupedProperties.map((group) => {
                if (!group._id || !group.properties?.length) return null;

                return (
                  <div key={group._id} className="space-y-4">
                    <h4 className="text-lg font-semibold uppercase tracking-wider">{group._id}S</h4>
                    <ul className="space-y-2">
                      {group.properties.map((property: any) => (
                        <li key={property._id || property.id}>
                          <Link
                            to={`/properties/${property.slug}`}
                            className="text-foreground/70 hover:text-gold transition-colors block text-sm"
                          >
                            {capitalizeWords(property.specifications.titleDeed)}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        <div className="pt-8 border-t border-foreground/20 text-center text-foreground/70 text-wide text-sm">
          <p>&copy; {currentYear} Urban Oasis. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
